import React from 'react';

import styles from './styles.m.scss';

const Resource = ({ resource }) => (
  <a key={resource.id} href={resource.url} target="_blank" className={styles.resource}>
    <img src={require(`../../../images/membership-resources/${resource.icon}.png`)} />
    <span>{resource.title}</span>
  </a>
);

export default Resource;
